import { useState } from 'react';
import type {
  CountrySelection,
  CountrySelectorRegion,
} from '../../types/CountrySelectorTypes';
import { CountrySelectorTrigger } from './CountrySelectorTrigger/CountrySelectorTrigger';
import { CountrySelectorMenu } from './CountrySelectorMenu/CountrySelectorMenu';

interface CountrySelectorProps {
  onSelect: (countrySelection: CountrySelection) => void;
  previousSelection: CountrySelection;
  regions: CountrySelectorRegion[];
  countrySelectorTitle: string;
  languageSelectorTitle: string;
  changeLanguageText: string;
  onToggle: (isOpen: boolean) => void;
  onCountrySelected?: (country: CountrySelection) => void;
  showCountrySelector: boolean;
  setShowCountrySelector: (showMenu: boolean) => void;
}

export function CountrySelector({
  onSelect,
  previousSelection,
  regions,
  countrySelectorTitle,
  languageSelectorTitle,
  changeLanguageText,
  onToggle,
  onCountrySelected,
  showCountrySelector,
  setShowCountrySelector,
}: CountrySelectorProps): JSX.Element {
  const handleToggleCountryMenu = () => {
    // onToggle will fire analytics that appropriately track how often a user is opening and closing
    // setShowCountrySelector will update the state to show or hide the selector
    onToggle(showCountrySelector);
    setShowCountrySelector(!showCountrySelector);
  };

  const handleOnSelect = (countrySelection: CountrySelection): void => {
    if (onCountrySelected) {
      onCountrySelected(countrySelection);
    }
    onSelect(countrySelection);
    setShowCountrySelector(false);
  };

  return (
    <>
      <CountrySelectorTrigger
        countryCode={previousSelection.countryCode}
        toggleCountryMenu={handleToggleCountryMenu}
      />
      <CountrySelectorMenu
        changeLanguageText={changeLanguageText}
        countrySelectorTitle={countrySelectorTitle}
        isOpen={showCountrySelector}
        languageSelectorTitle={languageSelectorTitle}
        onSelect={handleOnSelect}
        onToggle={handleToggleCountryMenu}
        previousSelection={previousSelection}
        regions={regions}
      />
    </>
  );
}
